











import Vue from 'vue';
import VFairService, { VFairOrganizationFAQ } from '~/services/VFairService';

export default Vue.extend({
    name: 'BoothFAQ',
    props: {
        vFairId: {
            type: String,
            required: true,
        },
        organizationId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            service: new VFairService(),

            loading: true,
            faqs: [] as VFairOrganizationFAQ[],
        };
    },
    methods: {
        fetchFAQs() {
            this.loading = true;
            this.service
                .getVFairOrganizationFAQs(this.vFairId, this.organizationId)
                .then(res => (this.faqs = res))
                .catch(console.error)
                .finally(() => (this.loading = false));
        },
    },
    mounted() {
        this.fetchFAQs();
    },
});
